import { createFileRoute } from "@tanstack/react-router";
import BcbstxInsurance, { config } from "@/pages/BcbstxInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbstx-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Texas TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Texas coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "BCBS Texas TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Texas coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbstx-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbstx-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbstxInsurance />;
}
